import type { GenerateSankeyToolOutput } from '@azymmetric/shared/tools/generate-sankey.tool-config';
import type { GetTechnologyToolOutput } from '@azymmetric/shared/tools/get-technology.tool-config';
import type { RenderArmyReadinessReportToolOutput } from '@azymmetric/shared/tools/render-army-readiness-report.tool-config';
import type { RenderNavyCostTimeReportToolOutput } from '@azymmetric/shared/tools/render-navy-cost-time-report.tool-config';
import type { RenderNavyReadinessReportToolOutput } from '@azymmetric/shared/tools/render-navy-readiness-report.tool-config';
import type { RenderSpaceForceReadinessReportToolOutput } from '@azymmetric/shared/tools/render-space-force-readiness-report.tool-config';
import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';

export type ArtifactKind =
  | 'armyReadinessReport'
  | 'navyCostTimeReport'
  | 'navyReadinessReport'
  | 'sankey'
  | 'spaceForceReadinessReport'
  | 'technology';

type BaseArtifact = {
  status: 'idle' | 'streaming';
  title: string;
};

export type UIArtifact =
  | (BaseArtifact & {
      content: RenderArmyReadinessReportToolOutput;
      kind: 'armyReadinessReport';
    })
  | (BaseArtifact & {
      content: RenderNavyCostTimeReportToolOutput;
      kind: 'navyCostTimeReport';
    })
  | (BaseArtifact & {
      content: RenderNavyReadinessReportToolOutput;
      kind: 'navyReadinessReport';
    })
  | (BaseArtifact & {
      content: GenerateSankeyToolOutput;
      kind: 'sankey';
    })
  | (BaseArtifact & {
      content: RenderSpaceForceReadinessReportToolOutput;
      kind: 'spaceForceReadinessReport';
    })
  | (BaseArtifact & {
      content: GetTechnologyToolOutput;
      kind: 'technology';
    });

const initialState = {
  artifact: null as UIArtifact | null,
};

export type ArtifactStore = {
  artifact: UIArtifact | null;

  // Actions
  hideArtifact: () => void;
  reset: () => void;
  setArtifact: (artifact: UIArtifact | null) => void;
};

export const artifactStore = createStore<ArtifactStore>((set) => ({
  ...initialState,

  hideArtifact: () => set({ artifact: null }),

  reset: () => set(initialState),

  setArtifact: (artifact) => set({ artifact }),
}));

export const useArtifactStore = (): ArtifactStore => useStore(artifactStore);
